module.exports = __webpack_public_path__ + "static/media/figure-8b.9386efad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-8b.jpg
// module id = 1213
// module chunks = 0